import type { useGetApplicationQuery } from '../../../../api/lendingApi/lendingApiQueries';
import { getDurationInMonths } from '../../../../helpers/product.helpers';
import type { useOffersUK } from '../../../../hooks/useOffers/useOffersUK';

const DEFAULT_MAX_TERM_MONTHS = 60;

type TApplication = ReturnType<typeof useGetApplicationQuery>['application'];
type TOffers = ReturnType<typeof useOffersUK>['offers'];

export const getLoanSummary = (application: TApplication, offers: TOffers) => {
  const requestedAmount = application?.requested_products?.[0]?.amount;
  const estimatedAmount =
    offers?.find((offer) => offer.is_suggested)?.max_amount ??
    offers?.[0]?.max_amount;

  const isEstimatedAmountSmaller =
    !!estimatedAmount && Number(estimatedAmount) < Number(requestedAmount);

  const showRequestedAmount = !estimatedAmount || isEstimatedAmountSmaller;
  const displayAmount = showRequestedAmount ? requestedAmount : estimatedAmount;

  const validDurations = offers
    ?.map((offer) => getDurationInMonths(offer.duration))
    .filter((d): d is number => d !== null);
  const maxTermLength =
    validDurations && validDurations.length > 0
      ? Math.max(...validDurations)
      : DEFAULT_MAX_TERM_MONTHS;

  return { displayAmount, maxTermLength, showRequestedAmount };
};
